import { render, staticRenderFns } from "./bv-tab-bar-icon.vue?vue&type=template&id=6c0e0f46&scoped=true"
import script from "./bv-tab-bar-icon.vue?vue&type=script&lang=js"
export * from "./bv-tab-bar-icon.vue?vue&type=script&lang=js"
import style0 from "./bv-tab-bar-icon.vue?vue&type=style&index=0&id=6c0e0f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e0f46",
  null
  
)

export default component.exports